var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99648 10.3999C7.11648 10.3999 6.39648 11.1199 6.39648 11.9999C6.39648 12.8799 7.11648 13.5999 7.99648 13.5999C8.87648 13.5999 9.59648 12.8799 9.59648 11.9999C9.59648 11.1199 8.87648 10.3999 7.99648 10.3999ZM17.5965 10.3999C16.7165 10.3999 15.9965 11.1199 15.9965 11.9999C15.9965 12.8799 16.7165 13.5999 17.5965 13.5999C18.4765 13.5999 19.1965 12.8799 19.1965 11.9999C19.1965 11.1199 18.4765 10.3999 17.5965 10.3999ZM12.7965 10.3999C11.9165 10.3999 11.1965 11.1199 11.1965 11.9999C11.1965 12.8799 11.9165 13.5999 12.7965 13.5999C13.6765 13.5999 14.3965 12.8799 14.3965 11.9999C14.3965 11.1199 13.6765 10.3999 12.7965 10.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.2009d173eff2a42b2fc38e8b82a7b1ff.svg";
export { ForwardRef as ReactComponent };